Router = App.loadClass 'core::Router'
Storage = App.loadClass 'core::Storage'

class exports.DefineRouter extends Router

    prefix: 'FieldsDefine'
    module_name: 'FieldsDefine'

    register: () ->
        @module = angular.module @module_name, ['ui.router', 'ui.bootstrap']

        @service 'grower::Angular/Data/PlantingRx/Services/LegendService', ['$rootScope']
        @service 'grower::Angular/Data/Services/LegacyHandlerService', [
            '$rootScope'
            '$timeout'
            'FieldsDefine.Services.LegendService'
        ]
        @service 'grower::Angular/Fields/Define/Services/UndoService', ['$rootScope']
        @service 'grower::Angular/Fields/Define/Services/ZonesService', ['$http', '$rootScope']
        @service 'grower::Angular/Fields/Define/Services/FieldsService', [
            '$http'
            '$rootScope'
            'FieldsDefine.Services.ZonesService'
            '$q'
        ]

        @service 'grower::Angular/Fields/Define/Services/PgisService', ['$http', '$rootScope',  '$q']
        @service 'grower::Angular/Fields/Define/Services/ValidationService', [
            '$state'
            'FieldsDefine.Services.FieldsService'
            'FieldsDefine.Services.ZonesService'
            'FieldsDefine.Services.PgisService'
            'Data.Services.LegacyHandlerService'
        ]

        @service 'grower::Angular/Fields/Define/Services/IrrigationDetails', ['$http', '$rootScope']

        # Sidebar Controller
        @controller 'grower::Angular/Fields/Define/SidebarController', [
            '$scope', '$transitions',
            'Core.Services.Steps',
            '$state',
            'Core.Services.Loading',
            '$http',
            '$location',
            'FieldsDefine.Services.FieldsService'
            'FieldsDefine.Services.ValidationService'
        ]

        # Management Zone Selection Controller
        @controller 'grower::Angular/Fields/Define/SelectZonesController', [
            '$scope', '$transitions',
            'FieldsDefine.Services.PgisService'
            'FieldsDefine.Services.ValidationService'
            'FieldsDefine.Services.ZonesService'
        ]

        # Management Zone Definition Controller
        @controller 'grower::Angular/Fields/Define/DefineZonesController', [
            '$scope', '$transitions',
            'zone_type'
            'FieldsDefine.Services.PgisService'
            'FieldsDefine.Services.ValidationService'
            'FieldsDefine.Services.UndoService'
        ]

        # Management Zone Settings Controller
        @controller 'grower::Angular/Fields/Define/ZoneRadioSettingsController', [
            '$scope', '$transitions',
            # See the resolve for states that use this controller
            'zone_type',
            'option_name',
            'option_type',
            'options',
            'FieldsDefine.Services.ValidationService',
            'FieldsDefine.Services.PgisService'
        ]

        # Management Zone Dropdown Table Controller
        @controller 'grower::Angular/Fields/Define/ZonesDropdownTableController', [
            '$scope', '$transitions',
            # See the resolve for states that use this controller
            'zone_type',
            'option_name',
            'option_type',
            'options',
            'FieldsDefine.Services.ValidationService',
            'FieldsDefine.Services.PgisService',
            'FieldsDefine.Services.ZonesService',
        ]

        # Irrigation zone settings step 2 controller
        @controller 'grower::Angular/Fields/Define/IrrigationSettings2Controller', [
            '$scope', '$transitions',
            # See the resolve for states that use this controller
            'zone_type',
            'option_name',
            'option_type',
            'options',
            'FieldsDefine.Services.ValidationService',
            'FieldsDefine.Services.PgisService',
            'FieldsDefine.Services.ZonesService',
        ]


        # Irrigation details controller
        @controller 'grower::Angular/Fields/Define/IrrigationDetailsController', [
            '$scope', '$transitions',
            'FieldsDefine.Services.ValidationService',
            'FieldsDefine.Services.IrrigationDetails',
            '$ngModal'
        ]

        # Finish Controller
        @controller 'grower::Angular/Fields/Define/FinishController', [
            '$scope', '$transitions',
            'FieldsDefine.Services.FieldsService',
            'FieldsDefine.Services.PgisService',
            'FieldsDefine.Services.ZonesService',
            '$state',
            '$timeout',
            'FieldsDefine.Services.ValidationService'
        ]

    registerRoutes: ($stateProvider) ->
        $stateProvider
            .state 'grower.fields-define',
                url: '/fields-define'
                templateUrl: 'backend/grower/fields/define/sidebar'
                controller: 'FieldsDefine.Controllers.SidebarController'

            .state 'grower.data-define',
                url: 'data-define/:field_id/:year'
                templateUrl: 'backend/grower/fields/define/sidebar'
                controller: [
                    '$scope',
                    '$state',
                    'FieldsDefine.Services.ValidationService',
                    '$stateParams',
                    ($scope, $state, $serv, $stateParams) ->
                        # ensure that all services are ready for a new process
                        $serv.cleanup()
                        # routed here from data->add->maps->draw
                        settings =
                            fid: $stateParams.field_id
                            year: $stateParams.year
                            process_mode: 'zone-add'
                            from_data: true
                        $serv.setModeSettings(settings)

                        $state.go('grower.fields-define')
                ]

            .state 'grower.fieldprint-define',
                url: 'data-define/:request'
                templateUrl: 'backend/grower/fields/define/sidebar'
                controller: [
                    '$scope',
                    '$state',
                    'FieldsDefine.Services.ValidationService',
                    '$stateParams',
                    ($scope, $state, $serv, $stateParams) ->
                        parameters = JSON.parse($stateParams.request)
                        # ensure that all services are ready for a new process
                        $serv.cleanup()
                        # move the map to the boundary
                        if not App.layer_store.exists(parameters.field_id)
                            App.layer_store.empty()
                            App.layer_store.loadField(parameters.field_id)

                        $serv.fields.year = parameters.year

                        # routed here from fieldprint
                        settings =
                            fid: parameters.field_id,
                            year: parameters.year,
                            crop: parameters.crop,
                            redirectId: parameters.redirectId,
                            redirectState: parameters.redirectState,
                            step: parameters.step,
                            process_mode: 'irrigation-add',
                            from_data: false

                        $serv.setModeSettings(settings)

                        $state.go('grower.fields-define')
                ]

            .state 'grower.fieldprint-edit-zone',
                url: 'fieldprint-edit-zone/:request'
                templateUrl: 'backend/grower/fields/define/sidebar'
                controller: [
                    '$scope',
                    '$state',
                    'FieldsDefine.Services.ValidationService',
                    '$stateParams',
                    ($scope, $state, $serv, $stateParams) ->
                        # ensure that all services are ready for a new process
                        $serv.cleanup()

                        # routed here from data->view->maps->mmz->edit
                        parameters = JSON.parse($stateParams.request)

                        # move the map to the boundary
                        if not App.layer_store.exists(parameters.field_id)
                            App.layer_store.empty()
                            App.layer_store.loadField(parameters.field_id)

                        $serv.fields.fields_id = parameters.field_id
                        $serv.fields.year = parameters.year

                        # set settings
                        $serv.setModeSettings
                            fid: parameters.field_id
                            process_mode: 'zone-edit'
                            year: parameters.year
                            layers_id: parameters.layer_id
                            layers_title: parameters.layers_title
                            redirectId: parameters.redirectId,
                            redirectState: parameters.redirectState,
                            step: parameters.step,
                            from_data: false

                        # begin process
                        $state.go('grower.fields-define')
                ]

            .state 'grower.fieldprint-add-crop-irrigation',
                url: 'fieldprint-add-crop-irrigation/:request'
                templateUrl: 'backend/grower/fields/define/sidebar'
                controller: [
                    '$scope',
                    '$state',
                    'FieldsDefine.Services.ValidationService',
                    '$stateParams',
                    ($scope, $state, $serv, $stateParams) ->
                        # ensure that all services are ready for a new process
                        $serv.cleanup()

                        # routed here from data->view->maps->mmz->edit
                        parameters = JSON.parse($stateParams.request)

                        # move the map to the boundary
                        if not App.layer_store.exists(parameters.field_id)
                            App.layer_store.empty()
                            App.layer_store.loadField(parameters.field_id)

                        $serv.fields.fields_id = parameters.field_id
                        $serv.fields.year = parameters.year

                        # set settings
                        $serv.setModeSettings
                            fid: parameters.field_id
                            process_mode: 'add-crop'
                            year: parameters.year
                            layers_id: parameters.layer_id
                            layers_title: parameters.layers_title
                            redirectId: parameters.redirectId,
                            redirectState: parameters.redirectState,
                            step: parameters.step,
                            crop: parameters.crop,
                            from_data: false

                        # begin process
                        $state.go('grower.fields-define')
                ]

            .state 'grower.data-edit-zone',
                url: 'data-edit-zone/:request'
                templateUrl: 'backend/grower/fields/define/sidebar'
                controller: [
                    '$scope',
                    '$state',
                    'FieldsDefine.Services.ValidationService',
                    '$stateParams',
                    ($scope, $state, $serv, $stateParams) ->
                        # ensure that all services are ready for a new process
                        $serv.cleanup()

                        # routed here from data->view->maps->mmz->edit
                        parameters = JSON.parse($stateParams.request)
                        fid = parameters.fields_id
                        year = parameters.year
                        layers_id = parameters.layer_id
                        layers_title = parameters.layer_title

                        $serv.zones_service.exists(layers_id, (response) =>
                            # only enter edit mode if the field exists
                            # https://www.pivotaltracker.com/story/show/115045937
                            if response.data.status.type is 'success'
                                $serv.setModeSettings
                                    fid: fid
                                    process_mode: 'zone-edit'
                                    year: year
                                    layers_id: layers_id
                                    layers_title: layers_title
                                    from_data: true
                                $state.go('grower.fields-define')
                            else
                                $state.go('grower.data.view')
                        )
                ]

            .state 'grower.fields-define.select-management-zones',
                url: '/management-zones'
                views:
                    'sidebar-step':
                        templateUrl: 'backend/grower/fields/define/step/select-management-zones'
                        controller: 'FieldsDefine.Controllers.SelectZonesController'

            .state 'grower.fields-define.irrigation-draw',
                url: '/irrigation-draw'
                resolve:
                    zone_type: -> 'irrigation'
                views:
                    'sidebar-step':
                        templateUrl: 'backend/grower/fields/define/step/irrigation-draw'
                        controller: 'FieldsDefine.Controllers.DefineZonesController'

            .state 'grower.fields-define.irrigation-settings1',
                url: '/irrigation-settings-1'
                resolve:
                    zone_type: -> 'irrigation'
                    option_name: -> 'irrigated'
                    option_type: -> 'button'
                    options: -> [
                        { value: 'Irrigated', btnclass: 'clickable-green' }
                        { value: 'Dryland', btnclass: 'clickable-red' }
                    ]
                views:
                    'sidebar-step':
                        templateUrl: 'backend/grower/fields/define/step/irrigation-settings1'
                        controller: 'FieldsDefine.Controllers.ZoneRadioSettingsController'

            .state 'grower.fields-define.irrigation-settings2',
                url: '/irrigation-settings-2'
                resolve:
                    zone_type: -> 'irrigation'
                    option_name: -> 'irrigated'
                    option_type: -> 'select'
                    options: -> [
                        { value: 20, name: '1' }
                        { value: 40, name: '2' }
                        { value: 60, name: '3' }
                        { value: 80, name: '4' }
                        { value: 100, name: '5' }
                    ]
                views:
                    'sidebar-step':
                        templateUrl: 'backend/grower/fields/define/step/irrigation-settings2'
                        controller: 'FieldsDefine.Controllers.IrrigationSettings2Controller'

            .state 'grower.fields-define.irrigation-details',
                url: '/irrigation-details'
                views:
                    'sidebar-step':
                        templateUrl: 'backend/grower/fields/define/step/irrigation-details'
                        controller: 'FieldsDefine.Controllers.IrrigationDetailsController'

            .state 'grower.fields-define.previous-crop-draw',
                url: '/previous-crop-draw'
                resolve:
                    zone_type: -> 'previous-crop'
                views:
                    'sidebar-step':
                        templateUrl: 'backend/grower/fields/define/step/previous-crop-draw'
                        controller: 'FieldsDefine.Controllers.DefineZonesController'

            .state 'grower.fields-define.previous-crop-settings1',
                url: '/previous-crop-settings-1'
                resolve:
                    zone_type: -> 'previous-crop'
                    option_name: -> 'previous_crop'
                    option_type: -> 'button'
                    options: -> [
                        { value: 'Corn (grain)', btnclass: 'clickable-yellow' }
                        { value: 'Soybeans', btnclass: 'clickable-green' }
                        { value: 'Other', btnclass: 'clickable-blue' }
                    ]
                views:
                    'sidebar-step':
                        templateUrl: 'backend/grower/fields/define/step/previous-crop-settings1'
                        controller: 'FieldsDefine.Controllers.ZonesDropdownTableController'

            .state 'grower.fields-define.productivity-draw',
                url: '/productivity-draw'
                resolve:
                    zone_type: -> 'productivity'
                views:
                    'sidebar-step':
                        templateUrl: 'backend/grower/fields/define/step/productivity-draw'
                        controller: 'FieldsDefine.Controllers.DefineZonesController'

            .state 'grower.fields-define.productivity-settings1',
                url: '/productivity-settings-1'
                resolve:
                    zone_type: -> 'productivity'
                    option_name: -> 'productivity'
                    option_type: -> 'button'
                    options: -> [
                        { value: 'High', btnclass: 'clickable-green' }
                        { value: 'Med', btnclass: 'clickable-yellow' }
                        { value: 'Low', btnclass: 'clickable-red' }
                    ]
                views:
                    'sidebar-step':
                        templateUrl: 'backend/grower/fields/define/step/productivity-settings1'
                        controller: 'FieldsDefine.Controllers.ZoneRadioSettingsController'

            .state 'grower.fields-define.productivity-settings2',
                url: '/productivity-settings-2'
                resolve:
                    zone_type: -> 'productivity'
                    option_name: -> 'productivity'
                    option_type: -> 'select'
                    options: -> [
                        { value: 20, name: '1' }
                        { value: 40, name: '2' }
                        { value: 60, name: '3' }
                        { value: 80, name: '4' }
                        { value: 100, name: '5' }
                    ]
                views:
                    'sidebar-step':
                        templateUrl: 'backend/grower/fields/define/step/productivity-settings2'
                        controller: 'FieldsDefine.Controllers.ZoneRadioSettingsController'

            .state 'grower.fields-define.finish',
                url: '/finish'
                views:
                    'sidebar-step':
                        templateUrl: 'backend/grower/fields/define/step/finish'
                        controller: 'FieldsDefine.Controllers.FinishController'
